<template>
  <div class="detail-workspace">
    <section class="detail-workspace__hero" v-loading="Loading">
      <div class="detail-workspace__logo">
        <img v-if="appDetail.logo" :src="appDetail.logo" alt="应用 Logo" />
        <div v-else class="detail-workspace__logo-fallback">APP</div>
      </div>
      <div class="detail-workspace__content">
        <span class="detail-workspace__eyebrow">Template Detail</span>
        <div class="detail-workspace__title-row">
          <h2 class="detail-workspace__title">
            {{ appDetail.name || '应用详情' }}
          </h2>
          <span class="detail-workspace__badge">
            {{ appDetail.templateType || '应用模板' }}
          </span>
        </div>
        <p class="detail-workspace__desc">{{ summaryText }}</p>
        <div class="detail-workspace__meta">
          <span class="detail-workspace__chip"><strong>ID</strong>{{ appID }}</span>
          <span class="detail-workspace__chip"><strong>当前分区</strong>{{ activeLabel }}</span>
          <span class="detail-workspace__chip"><strong>状态</strong>{{ appDetail.status || '-' }}</span>
        </div>
      </div>
    </section>

    <el-tabs class="customTabs" v-model="activeName" @tab-click="handleClick" type="border-card">
      <el-tab-pane label="基础信息" name="detail" v-if="baseInfo" key="1">
        <div class="detail-workspace__pane">
          <basic-info
            :marketID="marketID"
            :Loading="Loading"
            :appDetail="appDetail"
          ></basic-info>
        </div>
      </el-tab-pane>
      <el-tab-pane label="应用版本" name="versions" v-if="appVersion" key="2">
        <div class="detail-workspace__pane">
          <app-version
            :marketID="marketID"
            :Loading="Loading"
            :appDetail="appDetail"
          ></app-version>
        </div>
      </el-tab-pane>
      <el-tab-pane label="服务客户" name="customer" v-if="serverCustomer && appDetail.templateType == 'rainbond'" key="3">
        <div class="detail-workspace__pane">
          <app-customer
            :marketID="marketID"
            :Loading="Loading"
            :appDetail="appDetail"
          ></app-customer>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { fetchAppInfo } from '@/api/app';
import { havePerms } from '@/utils/auth';
import AppCustomer from '../components/appCustomer';
import AppVersion from '../components/appVersion';
import BasicInfo from '../components/basicInfo';
const defaultProductCate = {
  app_key_id: '',
  app_tag_ids: [],
  app_tags: [],
  appClassificationID: '',
  app_type_id: '',
  code_page: '',
  create_time: '',
  desc: '',
  download_count: '',
  enterprise_id: '',
  home_page: '',
  install_count: '',
  installDoc: '',
  introduction: '',
  joint_cloud_id: '',
  logo: '',
  name: '',
  orgID: '',
  appLevel: 'enterprise',
  pic: [],
  price: '0',
  publish_type: '',
  recommend: 0,
  show_count: '0',
  start_count: '',
  status: '',
  tags: [],
  update_time: '',
  useDoc: ''
};

export default {
  name: 'AppForm',
  components: { AppVersion, BasicInfo, AppCustomer },

  data() {
    return {
      isappData: false,
      app_types: [],
      TagList: [],
      isEdit: true,
      activeName: this.$route.params.tabMode
        ? this.$route.params.tabMode
        : 'detail',
      appData: Object.assign({}, defaultProductCate),
      appDetail: Object.assign({}, defaultProductCate),
      appID: this.$route.params.appID,
      deliveryRecordList: [],
      Loading: true
    };
  },
  created() {
    this.fetchAppInfo();
  },
  computed: {
    marketID() {
      return this.$store.state.enterprise.enterpriseInfo.marketID;
    },
    // 基础信息
    baseInfo() {
      return havePerms(['Market.Application.Update']);
    },
    // 应用版本
    appVersion() {
      return havePerms(['Market.Application.Version.List']);
    },
    serverCustomer() {
      return havePerms(['Market.Customer.List']);
    },
    activeLabel() {
      const map = {
        detail: '基础信息',
        versions: '应用版本',
        customer: '服务客户'
      };
      return map[this.activeName] || '详情';
    },
    summaryText() {
      const raw =
        this.appDetail.desc ||
        this.appDetail.introduction ||
        '统一管理应用模板的基础信息、版本资产和客户服务关系。';
      return String(raw)
        .replace(/<[^>]+>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .slice(0, 120);
    }
  },
  methods: {
    fetchAppInfo() {
      fetchAppInfo({ marketID: this.marketID, appID: this.appID })
        .then((res) => {
          this.Loading = false;
          this.appDetail = Object.assign({}, defaultProductCate, res);
          this.appDetail.initSuccess = true;
        })
        .catch((err) => {
          this.Loading = false;
          if (err.code == 404) {
            this.$router.push({
              name: 'templateManage'
            });
          }
        });
    },
    handleClick(tab) {
      this.activeName = tab.name;
      this.$router.push({
        name: 'StoreTemplateManageDetails',
        params: { tabMode: tab.name, appID: this.appID }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import 'src/styles/detail-workspace.scss';
</style>



// WEBPACK FOOTER //
// src/views/storeManage/appManage/appDetail/index.vue